<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit online exam type Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Save</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input exam type name!' }]}]"
            />
          </a-form-item>
          <a-form-item label="Exam Type Code">
          <a-input
            placeholder="Exam type code"
            v-decorator="['exam_type_code', {rules: [{ required: true, message: 'Please input exam type code!' }]}]"
          />
        </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditExamType',
  mounted: function () {
    this.$eventBus.$on('openExamTypeEditModal', this.showModal)
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      examTypeId: null,
    }
  },
  methods: {
    showModal: function(examTypeId) {
      this.examTypeId = examTypeId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/online-exam/examtype/' + examTypeId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['name', 'exam_type_code', 'description'])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/online-exam/examtype/' + this.examTypeId, {
                  name: values.name,
                  exam_type_code: values.exam_type_code,
                  description: values.description,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Exam type details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
